import Cookies from 'js-cookie';

const TOKEN_KEY = 'cdb_uid';
// const MINI_APP_LOGIN_STATUS = 'mini_app_is_login';

export default {
  name: 'miniprogram',
  // 微信小程序环境，没有登录的用户需要跳转小程序的登录界面，并且授权成功后才走正常订单流程
  // 微信小程序的登录和网页的登录态同步
  isLogin: () => {
    return !!Cookies.get(TOKEN_KEY);
  },
  gotoLogin(referer = '', target = '_blank') {
    // pageType=activity 通过赛博坦/pages/activity/index打开
    referer = encodeURIComponent(referer) || encodeURIComponent(`${window.location.href}&channel=poi&pageType=activity`);
    // window.wx.miniProgram.navigateTo({
    //   url: `/pages/api/login?referer=${referer}&target=${target}`
    // });
    // console.log('referer:::', referer);
    window.wx.miniProgram.navigateTo({
      url: `/pages/login/index?goback=${referer}&target=${target}&pagetype=other`
    });
  }
};
